/**
 * Centralized error messages for consistent error handling across the app
 * Supports English (en) and Vietnamese (vi)
 */

export interface ErrorMessage {
  title: string;
  description: string;
  hint?: string;
}

export interface ErrorMessages {
  en: ErrorMessage;
  vi: ErrorMessage;
}

export const ERROR_MESSAGES: Record<'initialization' | 'runtime' | 'component', ErrorMessages> = {
  initialization: {
    en: {
      title: 'Loading Error',
      description: 'The app encountered an initialization error. This is usually caused by browser cache or an outdated version.',
      hint: 'Try clearing your cache to fix this issue.',
    },
    vi: {
      title: 'Lỗi Tải Ứng Dụng',
      description: 'Ứng dụng gặp lỗi khi khởi động. Thường do cache trình duyệt hoặc phiên bản cũ.',
      hint: 'Thử xóa cache để khắc phục.',
    },
  },
  runtime: {
    en: {
      title: 'Something Went Wrong',
      description: 'An unexpected error occurred while running the application. This might be a temporary issue.',
      hint: 'Please try reloading the page.',
    },
    vi: {
      title: 'Đã Xảy Ra Lỗi',
      description: 'Một lỗi không mong muốn xảy ra khi chạy ứng dụng. Đây có thể là vấn đề tạm thời.',
      hint: 'Vui lòng thử tải lại trang.',
    },
  },
  component: {
    en: {
      title: 'Component Error',
      description: 'We encountered an error while loading this component. You can try refreshing or return to the home page.',
      hint: 'This error has been logged for investigation.',
    },
    vi: {
      title: 'Lỗi Thành Phần',
      description: 'Chúng tôi gặp lỗi khi tải thành phần này. Bạn có thể thử làm mới hoặc quay về trang chủ.',
      hint: 'Lỗi này đã được ghi nhận để kiểm tra.',
    },
  },
};
